/**
 * Reads a `Response` body as JSON, returning `null` instead of throwing when the
 * body is empty or not valid JSON. Lets callers branch on the parsed payload
 * without wrapping every `response.json()` in its own try/catch.
 */
export const parseJsonSafe = async (response: Response): Promise<any> => {
  try {
    return await response.json();
  } catch {
    return null;
  }
};

/**
 * Parses a JSON string, returning `null` when the input is empty/nullish or not
 * valid JSON — so a single malformed payload (e.g. a `params` column) can never
 * throw and break the mapping of an entire list.
 */
export const parseJsonStringSafe = <T = object>(value: string | null | undefined): T | null => {
  if (!value) return null;
  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
};
